import { FC, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './Auth/LoginForm';
import Navigation from './Navigation';
import DTR from './DTR';
import TimeRecordList from './TimeRecordList';
import Profile from './Profile';
import ThirstyRecords from './ThirstyRecords';
import Payslips from './Payslips';
import type { NavigationView } from '../types/navigation';
import { Outlet } from 'react-router-dom';

const Layout: FC = () => {
  const { user, loading } = useAuth();
  const [currentView, setCurrentView] = useState<NavigationView>('dtr');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginForm />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation currentView={currentView} onViewChange={setCurrentView} />
      <main className="pt-20">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;